module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4r6n9r-efd3cf1aac6d85ac1f8673ee501d123d.svg";